<!-- <mat-icon [ngClass]="{'animate' : animate}" [style.color]="animate ? colorEnd : colorStart" (click)="toggle($event)">{{animate ? end : start}}</mat-icon> -->

<bee-icon class="small" [ngClass]="{'animate' : animate}" [style.color]="animate ? colorEnd : colorStart" (click)="toggle($event)" [icon]="animate ? end : start"></bee-icon>
